export enum SearchParamsEnum {
  token = 'token',
  lang = 'lang',
  question_id = 'question_id',
  period = 'period',
  clientToken = 'olybetToken',
}
